import { useEffect } from 'react';

// Logs them out after a specified time (in minutes)
export const useInactivity = (loggedIn, logout, time) => {
  useEffect(() => {
    if (loggedIn) {
      // Convert time from minutes to ms.
      const timeMS = time * 60 * 1000;
      return setupInactivityTimer(logout, timeMS);
    }
  }, [loggedIn]);
};

function setupInactivityTimer(logout, time) {
  let timerID;

  function startTimer() {
    timerID = window.setTimeout(logout, time);
  }

  function resetTimer() {
    window.clearTimeout(timerID);
    startTimer();
  }

  function setupListeners() {
    document.addEventListener('mousemove', resetTimer);
    document.addEventListener('mousedown', resetTimer);
    document.addEventListener('keypress', resetTimer);
    document.addEventListener('touchmove', resetTimer);
    document.addEventListener('onscroll', resetTimer);
    startTimer();
  }

  setupListeners();

  return function cleanupInactivityTimer() {
    document.removeEventListener('mousemove', resetTimer);
    document.removeEventListener('mousedown', resetTimer);
    document.removeEventListener('keypress', resetTimer);
    document.removeEventListener('touchmove', resetTimer);
    document.removeEventListener('onscroll', resetTimer);
    window.clearTimeout(timerID);
  };
}
